import CircularProgress from "@mui/material/CircularProgress";

interface LoadingProps {
  size?: string;
}

export default function Loading({size, ...props}: LoadingProps) {
  return <CircularProgress size={size} {...props} />
}
